import { initializeBugsnag, initializeDatadog } from 'cfa-react-logging';
import { Store } from '@reduxjs/toolkit';

import ooeConstants from '../constants';
import { getUserData } from '../util/loggerStateData';

export const setupLogging = (getState: Store['getState']) => {
  initializeBugsnag({
    apiKey: ooeConstants.BUGSNAG_API_KEY,
    appVersion: ooeConstants.APP_VERSION,
    environment: ooeConstants.BUGSNAG_RELEASE_STAGE,
    enabled: ooeConstants.LOGGING_ENABLED,
    excludedErrorMessageLabels: [],
    trackingDomains: ['order-management.cfahome.com'],
    excludedTrackingDomainErrors: [
      'mparticle',
      'amplitude',
      'google-analytics',
      'pinterest',
      'doubleclick',
      'cookielaw',
      'taplytics',
    ],
    getUserMetadata: () => {
      const state = getState();
      return getUserData(state);
    },
  });

  initializeDatadog({
    applicationId: ooeConstants.DATADOG_APP_ID,
    clientToken: ooeConstants.DATADOG_CLIENT_TOKEN,
    serviceName: ooeConstants.DATADOG_SERVICE_NAME,
    appVersion: ooeConstants.APP_VERSION,
    environment: ooeConstants.ENV,
    enabled: ooeConstants.LOGGING_ENABLED,
    tracingUrls: ['order-management.cfahome.com', ooeConstants.REX_CATERING_BASE],
    sessionSampleRate: 100,
  });
};
